import { useIntl } from 'react-intl'
import Head from 'components/Head'
import { Page } from 'layouts/pages'
import { Main, Content, Header, Aside } from 'components/page'
import WeatherSidebar from 'layouts/weather/forecast/Sidebar'
import * as Layouts from 'layouts/glossary/layouts'
import * as Glossary from '@avcan/prismic/clients/glossary'
import styles from 'layouts/glossary/Glossary.module.css'

export async function getStaticProps({ locale }) {
    const { layout, definitions } = await Glossary.getLayout('weather', locale)

    return {
        props: {
            layout,
            definitions,
            sections: Layouts.createSections(layout.data, definitions),
        },
    }
}

export default function WeatherGlossary(props) {
    const intl = useIntl()
    const title = intl.formatMessage({
        description: 'Weather Glossary',
        defaultMessage: 'Weather Glossary',
    })

    return (
        <Page className={styles.Page}>
            <Head title={title} description={title} />
            <Header title={title} />
            <Content>
                <Main>
                    <Layouts.Glossary {...props} />
                </Main>
                <Aside>
                    <WeatherSidebar />
                </Aside>
            </Content>
        </Page>
    )
}
